import { ToastQueue } from "../Components/Common/spectrumCompat";

export type DisplayToastOptions = {
  type: "info" | "error" | "success" | "warning";
  text: string;
  /** When true (default), toast auto-dismisses after ~5s (Spectrum minimum for accessibility). */
  autoClose?: boolean;
};

/**
 * App toasts via React Spectrum S2 ToastQueue.
 * Requires `<ToastContainer />` from `@react-spectrum/s2` under an S2 `<Provider>`.
 */
export function displayToasts(options: DisplayToastOptions): void {
  const message = String(options.text ?? "");
  const timeout = options.autoClose === false ? undefined : 5000;

  switch (options.type) {
    case "error":
      ToastQueue.negative(message, { timeout });
      break;
    case "success":
      ToastQueue.positive(message, { timeout });
      break;
    case "info":
      ToastQueue.info(message, { timeout });
      break;
    case "warning":
      ToastQueue.neutral(message, { timeout });
      break;
    default:
      ToastQueue.neutral(message, { timeout });
  }
}
